import axios from 'axios';

export const propHandler = () => {
    return axios.get('/api/slidenauth')
    .then(response => response.data)
    .catch(error => {
        throw error;
    });
};